// ── src/apolloClient.ts ────────────────────────────────────────────
import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
 
/* ---------------------------------------------------------------
   1.  Build the full URL **only if** REACT_APP_BACKEND_ADDR exists.
       Otherwise fall back to the relative proxy path (/api/graphql).
   --------------------------------------------------------------- */
const proto = process.env.REACT_APP_BACKEND_PROTO;          // e.g. 'https'
const host  = process.env.REACT_APP_BACKEND_ADDR;           // e.g. 'backend.probonoh2020kb.eu'
const port  = process.env.REACT_APP_BACKEND_PORT;           // e.g. '443'
 
// helper → omit :80 / :443 in final URL
const needsPort = port && port !== '80' && port !== '443';
 
const absoluteUrl =
  proto && host
    ? `${proto}://${host}${needsPort ? `:${port}` : ''}/graphql`
    : null;                                                 // env not set → use relative path
 
/* ---------------------------------------------------------------
   2.  HTTP link
   --------------------------------------------------------------- */
const httpLink = createHttpLink({
  uri: absoluteUrl ?? '/api/graphql',   // ← production vs dev
  // credentials: 'include',
});
 
/* ---------------------------------------------------------------
   3.  Attach the JWT (unchanged)
   --------------------------------------------------------------- */
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('authToken');
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
    },
  };
});
 
/* --------------------------------------------------------------- */
export default new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});